import { login, logout, permissions, arealist } from "../../api/login";
// import { setparam } from "@/api/api.js";
import { getToken, setToken, removeToken } from "../../utils/auth";
import { resetRouter } from "@/router";
import Cookies from "js-cookie";
import md5 from "js-md5";
import router from "@/router"
const getDefaultState = () => {
  return {
    userData:{},
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    roles_menu: [],
    roles_sass_menu: [],
    but: [],
    natural: [],
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    console.log("token变了", token);
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_MENUS: (state, { menu, saas_menu }) => {
    state.roles_menu = menu;
    state.roles_sass_menu = saas_menu;
  },
  SET_BUT: (state, but) => {
    state.but = but;
  },
  SET_NATURAL: (state, natural) => {
    console.log("查询权限", natural);

    state.natural = natural;
  },
  SET_USERDATA: (state, userData) => {
 

    state.userData = userData;
  },
};

const actions = {
  setRoles({ commit }, menu) {
    commit("SET_ROLES", menu);
  },
  setUserData({ commit }, data) {
    // setToken(data);
    commit("SET_USERDATA", data);
  },
  // user login
  login({ commit }, userInfo) {
    const { username, password,captcha,user_type } = userInfo;
    return new Promise((resolve, reject) => {
      login({
        username,
        password,
        captcha,
        user_type
      })
        .then((response) => {
          localStorage.setItem("sunshineUser",JSON.stringify(response.result))
          let userinfo = JSON.stringify(response.result);
          commit("SET_TOKEN", response.result);
          commit("SET_NAME", response.result.user_name);
          // setToken(userinfo);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取用户权限信息
  getInfo({ commit }, store_id) {
    const _this = this;

    return new Promise((resolve, reject) => {
      permissions(store_id)
        .then((response) => {
          /**
           * menu：阳光收银 saas_menu：sass门店信息
           */
         

          // //** */

          const { menu, but, saas_menu, natural } = response.result;
          let _menu = [];
          commit("SET_BUT", but);
          commit("SET_NATURAL", natural);
          let menu1 = [];
          if (JSON.parse(getToken()).enable_warehouse1 === 0) {
            
            menu.map((item) => {
              if (
                item != 239 &&
                item !== 249 &&
                item !== 251 &&
                item !== 252 &&
                item !== 268
              ) {
                menu1.push(item);
              }
            });
            //不显示直拨入库订单 总库出库   总库退货  二级退库
          } else {
            menu1 = menu.filter(
              (item) => item !== 361 //不显示二级退货
            );

          }
          commit("SET_MENUS", { menu:menu1, but, saas_menu });
          // 两个权限都有 取缓存，没缓存跳阳光收银
          if (menu.length && saas_menu.length) {
            if (Cookies.get("APP_CURRENT_ROLES") == 0) {
              _menu = saas_menu;
            } else {
              _menu = menu;
            }
          } else if (saas_menu.length > 0) {
            _menu = saas_menu;
          } else if (menu.length > 0) {
            _menu = menu;
          } else {
            // 都为空给默认首页
            _menu = [1];
          }
          // Cookies.remove("APP_CURRENT_ROLES");
          console.log(_menu, "_menu");
          let arr1 = [];
          if (JSON.parse(getToken()).enable_warehouse1===0){
            
            _menu.map(item=>{
              if (
                item != 239 &&
                item !== 249 &&
                item !== 251 &&
                item !== 252 &&
                item !== 268
              ) {
                arr1.push(item);
              }
                
            })
           
                //不显示直拨入库订单 总库出库   总库退货  二级退库
           
            commit("SET_ROLES", arr1);
          }else{
            arr1 = _menu.filter(
              (item) =>
                item !== 361 //不显示二级退货
            );
            commit("SET_ROLES", arr1);
          }
           
          // resolve(response.result);
          resolve({ but, menu: arr1 });
        })
        .catch((error) => {
          reject(error.msg || "Error");
          console.log(error);
        });
    });
  },
  // user logout
  logout({ commit }) {
    return new Promise((resolve) => {
      logout()
        .then(() => {
          cleanupAfterLogout(commit);
          resolve();
        })
        .catch((error) => {
          console.error("Logout API gagal:", error);
          cleanupAfterLogout(commit);
          resolve();
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      commit("SET_ROLES", []);
      resolve();
    });
  },
  //
  setNatural({ commit }, prams) {
    console.log("daole------------", prams);
    return new Promise((resolve) => {
      setparam(prams).then((res) => {
        commit("SET_NATURAL", prams.ids);
      });
      resolve();
    });
  },
};

function cleanupAfterLogout(commit) {
  commit("tagsView/DEL_ALL_CACHED_VIEWS", null, { root: true });
  commit("tagsView/DEL_ALL_VISITED_VIEWS", null, { root: true });

  localStorage.removeItem("hpToken");
  commit("RESET_STATE");
  commit("SET_ROLES", []);
  localStorage.setItem("sunshineUser", "");
  localStorage.setItem("systemState", "login");

  router.replace("/login");
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
